module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-14.ec575b8.woff2";